import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-price-with-currency',
	templateUrl: './price-with-currency.component.html',
	styleUrls: ['./price-with-currency.component.css'],
})
export class PriceWithCurrencyComponent {
	@Input() value: string = null;
	@Input() currency: string = null;
	@Input() currencies: Array<any> = [
		{
			id: 'pln',
			name: 'PLN',
		},
		{
			id: 'eur',
			name: 'EURO',
		},
	];
	@Output() valueChange = new EventEmitter();
	@Output() currencyChange = new EventEmitter();

	constructor() {}

	submit() {
		if (!this.value || !this.currency) {
			return;
		}
		this.valueChange.emit(this.value);
		this.currencyChange.emit(this.currency);
	}
}
